import React from 'react';
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, styled } from "@mui/material";
import { COLOR_MAP } from '../../constants/ColorNames';
import { INFO_ICON } from '../../constants/icons/InfoIcon';
import Tooltip from './Tooltip';

type RadioGroupProps = {
  label?: string | React.ReactNode;
  options: { label: string, value: string, infoText?: string; }[];
  value: string;
  onChange: (event: React.ChangeEvent, value: string) => void,
  direction?: 'row' | 'column';
  gap?: string;
  disabled?: boolean;
}

const StyledFormControlLabel = styled(FormControlLabel)`
    margin-right:2.4rem !important;

    .MuiRadio-root {
       padding: 0 0.8rem!important;
    }
    .MuiFormControlLabel-label {
      font-weight: 400;
      font-size: 1.2rem;
      line-height: 1.6rem;
      color: ${COLOR_MAP.LIGHT_GREY};
      display: flex;
      align-items: center;
      gap: 4px;
    }
`

const RadioButtonGroups = (props: RadioGroupProps) => {
  const { label, options, value, onChange, direction = 'row', gap = '0px', disabled=false } = props;
  return (
    <FormControl disabled={disabled}>
      {label ? <FormLabel id="demo-row-radio-buttons-group-label">{label}</FormLabel> : null}
      <RadioGroup
        sx={{
          gap: gap
        }}
        row={direction === 'row'}
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        onChange={onChange}
        value={value}
      >{
          options && options.length ?
            options.map((item => {
              return <StyledFormControlLabel value={item.value}
                control={<Radio
                  sx={{
                    color: COLOR_MAP.GREY_2,
                    '& .MuiSvgIcon-root': {
                      fontSize: `14 !important`,
                    },
                    '&.Mui-checked': {
                      color: `${COLOR_MAP.GREY_2} !important`,
                    }
                  }}
                />} label={
                  <>
                    {item.label}
                    <Tooltip
                      title={item.infoText ||''}
                      disabled={disabled}
                      >
                        <div style={{marginTop:'4px'}}>
                      <INFO_ICON fill={disabled ? 'rgba(0, 0, 0, 0.38)': 'rgb(29, 25, 52)'} height={12} width={12}/>
                      </div>
                    </Tooltip>
                  </>} />
            }))
            : null
        }
      </RadioGroup>
    </FormControl>
  )
}

export default RadioButtonGroups;
